import SignUp from "./SignUp";
import signUpSaga from "./saga";
export { signUpSaga };
export default SignUp;
